import { NavLink } from 'react-router-dom';
import { NAV_ITEMS, NAV_ITEMS_AUTHED } from '@/lib/routes';
import { cn } from '@/lib/utils';
import { RobotSelector } from '@/components/nav/RobotSelector';
import { OrgSelector } from '@/components/nav/OrgSelector';
import { useEffectiveOrgName } from '@/stores/useOrgStore';
import { UserMenu } from '@/components/auth/UserMenu';
import { ThemeToggle } from '@/components/layout/theme-toggle';

export function NavPill() {
  // Hide the slot (and its bracketing dividers) when we have no org context.
  // That covers kiosk mode, the brief moment before /me + /orgs land, and
  // anyone whose calls failed — we never want a floating empty gap.
  const showOrgSlot = useEffectiveOrgName() != null;
  // Only show authed-only tabs (e.g. Event Log) when we have an org context,
  // which implies the user is signed in and /me has resolved.
  const isLoggedIn = showOrgSlot;
  const navItems = isLoggedIn ? [...NAV_ITEMS, ...NAV_ITEMS_AUTHED] : NAV_ITEMS;
  return (
    // Outer pill caps at viewport width so it can never get clipped on
    // narrow / portrait screens (e.g. iPad portrait, rotated kiosk). Inner
    // children are non-shrinking — the pill scrolls horizontally if its
    // content really doesn't fit. Padding/text scale down below sm.
    <nav className="flex items-center gap-1 bg-surface/95 backdrop-blur-md border-2 border-border rounded-full px-2 py-1.5 shadow-lg max-w-[calc(100vw-1.5rem)] overflow-x-auto scrollbar-none">
      {navItems.map(({ label, path }) => (
        <NavLink
          key={path}
          to={path}
          end={path === '/'}
          className={({ isActive }) =>
            cn(
              'shrink-0 px-3 sm:px-4 py-1.5 rounded-full text-xs sm:text-sm font-semibold transition-colors',
              isActive
                ? 'bg-accent/15 text-accent'
                : 'text-muted hover:text-foreground'
            )
          }
        >
          {label}
        </NavLink>
      ))}
      {showOrgSlot && (
        <>
          <div className="shrink-0 w-px h-4 bg-border mx-1" />
          <div className="shrink-0"><OrgSelector /></div>
        </>
      )}
      <div className="shrink-0 w-px h-4 bg-border mx-1" />
      <div className="shrink-0"><RobotSelector /></div>
      <div className="shrink-0 w-px h-4 bg-border mx-1" />
      <div className="shrink-0"><ThemeToggle /></div>
      <div className="shrink-0 w-px h-4 bg-border mx-1" />
      <div className="shrink-0"><UserMenu /></div>
    </nav>
  );
}
